import { Flex, Paper, Text } from '@mantine/core';

import { formatHumanizedDuration } from '@feature/utils';
import { Validation } from '@feature/validation/ValidationTypes';

interface ValidationCardProps {
  validation: Validation;
}

export function ValidationCard({ validation }: ValidationCardProps) {
  return (
    <Paper p="sm">
      <Flex>
        {validation.status === 'VALIDATED' && <Text c="green">Validat</Text>}
        {validation.status === 'REJECTED' && <Text c="red">Respins</Text>}
        <Text ml="6px">de către</Text>
        <Text
          ml="6px"
          fw="500"
        >
          {validation.validatedBy.name}
        </Text>
      </Flex>
      <Text
        size="xs"
        c="dimmed"
        fs="italic"
      >
        {formatHumanizedDuration(validation.createdAt)}
      </Text>
      <Text>{validation.note}</Text>
    </Paper>
  );
}
